export class BudgetPickerControl {
  el: JQuery;

  constructor(private id: string) {
    this.el = $("#" + this.id);
    this.updateTotal();
    this.hookInputs();
  }

  hookInputs() : void {
    const me = this;

    this.el.find("input.currency").on("keyup", function (e) {
      me.updateRow($(e.currentTarget));
      me.updateTotal();
    });
  }
  
  updateRow(input: JQuery) : void {
    const value =  input.val() as string;
    let amount = window.Globalize.parseNumber(value);
    amount = isNaN(amount) ? 0 : amount;
    const $row = input.closest("tr");
    const amountAvailable = window.Globalize.parseNumber($row.data("amount-available"));
    const amountPlanned = window.Globalize.parseNumber($row.data("amount-planned"));
    $row.find("td.amount-available").text(this.format(amountAvailable - amount));
    $row.find("td.amount-planned").text(this.format(amountPlanned + amount));
  }
  
  updateTotal(): void {
    const amountAvailable = this.sum("td.amount-available");
    const amountPlanned = this.sum("td.amount-planned");
    $("#totalAmountAvailable").text(this.format(amountAvailable));
    $("#totalAmountPlanned").text(this.format(amountPlanned));
    $("#totalBudgetInvalid").toggleClass("d-none", amountAvailable >= 0);
    $("#total").text(this.format(this.sum("input.currency")));
  }

  sum(selector: string):number {
    let result = 0;
    this.el.find(selector).each(function (_, e) {
      const value = window.Globalize.parseNumber(($(e).val() as string)?.length ? $(e).val() as string : $(e).text());
      result += isNaN(value) ? 0 : value;
    });
    return result; 
  }

  format(val: number): string {
    return window.Globalize.formatNumber(val, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
}
